import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DropDownListComponent, ChangeEventArgs, FieldSettingsModel } from '@syncfusion/ej2-react-dropdowns';

import { IOfficesListFilterProps } from '../../../interfaces/props/IOfficesListProps';
import { CheckBoxStates } from '../../../common/model/enumerations/checkBoxStates.model';
import { enumToArray } from '../../../utils/enum.utils';
import * as checkBoxStateUtils from '../../../utils/checkBoxState.utils';
import TextBox from '../../../components/filters/textBox';

type OfficesListFilterPropsType = IOfficesListFilterProps & WithTranslation;

class OfficesListFilter extends Component<OfficesListFilterPropsType> {
  public activeDropDownListComponent: DropDownListComponent = null;
  public activeCheckBoxOptions: Record<string, string | number>[] = [];
  public activeFields: FieldSettingsModel = { text: 'text', value: 'value', iconCss: 'iconCss' };

  public constructor(props: OfficesListFilterPropsType) {
    super(props);
    this.activeCheckBoxOptions = enumToArray(CheckBoxStates, 'number', 'text', 'value').map((item) => ({
      ...item,
      text: checkBoxStateUtils.getLocalizedYesNoIndiferentText(props.i18n, item.value.toString()),
      iconCss: checkBoxStateUtils.getIconCss(item.value as number)
    }));
  }

  public onDescriptionChange(value: string) {
    this.props.onDescriptionChange(value);
  }

  public onCodeChange(value: string) {
    this.props.onCodeChange(value);
  }

  public onEmailsChange(value: string) {
    this.props.onEmailsChange(value);
  }

  public onActiveChange(e: ChangeEventArgs) {
    this.props.onActiveChange(checkBoxStateUtils.convertIntToBoolean(e.value as number));
  }

  public updateActiveDropDownListComponentValueTemplate() {
    if (this.activeDropDownListComponent) {
      const selectedActiveOption = this.activeCheckBoxOptions.find((activeOption) => activeOption.value === checkBoxStateUtils.convertBooleanToInt(this.props.filter.active));
      if (selectedActiveOption) {
        this.activeDropDownListComponent.valueTemplate = `
          <div class="row no-gutters pl-3 pr-3 h-100">
            <div class="col align-self-center">
              <span class="${`mr-2 ${selectedActiveOption.iconCss}`}" ></span>
              <span>${selectedActiveOption.text}</span>
            </div>
          </div>
        `;
      }
    }
  }

  public render() {
    const {
      filter,
      isFetching,
      onFilterButtonClick,
      i18n,
    } = this.props;

    return (
      <form onSubmit={(e: React.FormEvent) => { e.preventDefault(); onFilterButtonClick(); }}>
        <div className='row'>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('office.code')}</div>
                <TextBox
                  name='code'
                  value={filter.code}
                  showClearButton={true}
                  onChange={(value) => this.onCodeChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('office.description')}</div>
                <TextBox
                  name='description'
                  value={filter.description}
                  showClearButton={true}
                  onChange={(value) => this.onDescriptionChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('office.emails')}</div>
                <TextBox
                  name='emails'
                  value={filter.emails}
                  showClearButton={true}
                  onChange={(value) => this.onEmailsChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('office.active')}</div>
                <DropDownListComponent
                  fields={this.activeFields}
                  dataSource={this.activeCheckBoxOptions}
                  value={checkBoxStateUtils.convertBooleanToInt(filter.active)}
                  ref={(dropDownListComponent: DropDownListComponent) => {
                    this.activeDropDownListComponent = dropDownListComponent;
                    this.updateActiveDropDownListComponentValueTemplate();
                  }}
                  sortOrder="Ascending"
                  change={(e) => this.onActiveChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='row justify-content-end'>
          <div className='col-auto'>
            <button type='submit' className='btn btn-secondary' title={i18n.t('actions.filter')} disabled={isFetching}>
              {isFetching
                ? <span className='spinner-border spinner-border-sm' />
                : <span className='icon icon-app-item-search' />
              }
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default withTranslation()(OfficesListFilter);
